<template>
  <div class="pictures">
    <div class="top orangeToYellow">
      <span>摄像头图片</span>
    </div>
    <div class="body">
      <PicList />
    </div>
  </div>
</template>

<script>
import PicList from './../components/picList'
export default {
  components: {
    PicList,
  },
  props: {},

  data() {
    return {
      visible: false,
    }
  },

  mounted() {
    const body = document.getElementsByTagName('body')[0]
    console.log('body:', body)
    body.style.height = 'auto'
  },

  methods: {},
}
</script>

<style>
/* body {
  height: auto;
  min-height: 100%;
} */
</style>

<style lang="scss">
* {
  font-size: 14px;
}

.pictures {
  min-height: 100%;
}

.top {
  height: 60px;
  color: #ffffff;
  font-size: 16px;
  line-height: 60px;
  padding: 0 10px;
}

.body {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  min-height: calc(100% - 90px);
  padding: 0 0.2rem;
  justify-content: space-between;
  text-align: left;
  padding-top: 10px;
  box-sizing: border-box;
}
</style>
